import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import HotelIcon from "@mui/icons-material/Hotel";
import RepeatIcon from "@mui/icons-material/Repeat";
import Typography from "@mui/material/Typography";
import TimelineInfo from "../../components/TimelineInfo";

const timelines = [
  {
    event: "IT Week Programming Tournament (Interschool Division)",
    place: "Champion",
    date: "November 2018",
  },
  {
    event: "ACM-ICPC Philippines Davao Region Programming Contest",
    place: "3rd place",
    date: "February 2019",
  },
  {
    event: "Mindanao Competitive Programming Summer Camp",
    place: "3rd place",
    date: "May 2019",
  },
  {
    event: "Android Masters",
    place: "Top 5 Finalist",
    date: "September 2019",
  },
  {
    event: "NASA International Space-Apps Challenge",
    place: "Participant",
    date: "October 2019",
  },
  {
    event: "Blockathon",
    place: "Participant",
    date: "October 2019",
  },
  {
    event: "ACM-ICPC Asia Regional Programming Contest",
    place: "Participant",
    date: "December 2019",
  },
  {
    event: "Smartsweep '16",
    place: "Finalist",
    date: "January 2020",
  },
  {
    event: "ACM-ICPC Philippines Davao Region Programming Contest",
    place: "3rd place",
    date: "February 2020",
  },
  {
    event: "Hackfest 2020",
    place: "Finalist",
    date: "November 2020",
  },
];

export default function Activities() {
  return (
    <div className="py-40">
      <div className="max-w-screen-lg mx-auto">
        <h1 className="text-center font-bold font-primary text-4xl mb-16">
          Participated Activities
        </h1>
        <Timeline position="alternate">
          {timelines.map((item, index) => (
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: "auto 0" }}
                align="right"
                variant="body2"
                color="text.secondary"
              >
                {item.date}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: "12px", px: 2 }}>
                <TimelineInfo event={item.event} place={item.place} />
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </div>
    </div>
  );
}
